// WARNING: this file is AUTOGENERATED, only main.ts and index.ts are editable
// rerun yarn generate:enums to update

import { ITranslationTable } from '../EnumClass';

export const name: ITranslationTable = {
  /* eslint-disable max-len */
  'Europe/Belfast': (t, data?, options?) => t('enum.alias-timezones.europe-belfast.name', data, options),
  'Europe/Bratislava': (t, data?, options?) => t('enum.alias-timezones.europe-bratislava.name', data, options),
  'Europe/Ljubljana': (t, data?, options?) => t('enum.alias-timezones.europe-ljubljana.name', data, options),
  'Europe/Podgorica': (t, data?, options?) => t('enum.alias-timezones.europe-podgorica.name', data, options),
  'Europe/Sarajevo': (t, data?, options?) => t('enum.alias-timezones.europe-sarajevo.name', data, options),
  'Europe/Skopje': (t, data?, options?) => t('enum.alias-timezones.europe-skopje.name', data, options),
  'Europe/Tiraspol': (t, data?, options?) => t('enum.alias-timezones.europe-tiraspol.name', data, options),
  'Europe/Vaduz': (t, data?, options?) => t('enum.alias-timezones.europe-vaduz.name', data, options),
  'Europe/Zagreb': (t, data?, options?) => t('enum.alias-timezones.europe-zagreb.name', data, options),
  /* eslint-enable max-len */
};
